import { PaymentStatuses, SessionPaymentStatuses } from "./Balance";
import { TypeUserData } from "./TypeUsers";

export enum Currencies {
  UAH = "uah",
  EUR = "eur",
  USD = "usd",
  PLN = "pln",
}

export enum PayRequestsStatuses {
  NEW = "new",
  PENDING = "pending",
  SUCCESS = "success",
  FAILED = "failed",
  CANCELED = "canceled",
  REJECTED = "rejected",
}

export type BankPayoutInfo = {
  _id: string;
  user: TypeUserData;
  name: string;
  surname: string;
  bankName: string;
  ibanOrAccNumber: string;
  swiftOrBic?: string;
  address: string;
  egrpouOrInn: string;
  currency: Currencies;
};

export type BankPayRequest = {
  _id: string;
  user: TypeUserData;
  payoutInfo: BankPayoutInfo;
  amount: number;
  status: PayRequestsStatuses;
  cancelationReason?: string;
  date?: string;
};

export type PayoneerPayoutInfo = {
  _id: string;
  user: TypeUserData;
  payoneerEmail: string;
  currency: Currencies;
};

export type PayoneerPayRequest = {
  _id: string;
  user: TypeUserData;
  payoutInfo: PayoneerPayoutInfo;
  amount: number;
  status: PayRequestsStatuses;
  cancelationReason?: string;
  date?: string;
};

export type TransactionsType = {
  _id: string;
  amount: number;
  type: "WITHDRAWAL" | "SESSION_PAYMENT" | "BALANCE_DEPOSIT";
  date: string;
  status: PaymentStatuses | PayRequestsStatuses | SessionPaymentStatuses;
  incremental: boolean;
  withdrawMethod?: "BANK_TRANSFER" | "PAYONEER";
  fee?: number;
  balanceAfterTransaction?: number;
};
